<template>
	<v-container grid-list-xl class="pa-0 ma-0">
		<v-layout row wrap>
			<v-flex
				class="d-flex flex-column"
				xs12
				md3
				v-for="(product, index) in products.data"
				:key="index"
			>
				<ShopProductCard
					:product="product"
					@succeed="$emit('succeed')"
					:type="type"
				></ShopProductCard>
			</v-flex>
			<v-flex xs12 class="text-center">
				<!-- <v-pagination
					v-model="products.meta.current_page"
					:length="products.meta.last_page"
					@input="onPageChange"
				></v-pagination> -->
				<Link
					as="v-btn"
					v-for="(link, index) in products.meta.links"
					:key="index"
					v-html="link.label"
					class="mx-3 my-2"
					link
					:href="link.url"
					:input-value="link.active"
					ripple
					tile
					:color="link.active ? 'secondary' : 'accent'"
				>
				</Link>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import ShopProductCard from "./ShopProductCard.vue";
import { Link } from "@inertiajs/inertia-vue";
export default {
	components: {
		Link,
		ShopProductCard,
	},
	props: ["products", "type"],

	methods: {
		onPageChange() {
			//
		},
	},
};
</script>
